const regex = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~ ]/g

export const formatLocation = (location?: string) => {
  if (!location) return ''
  return location.toLowerCase().replace(regex, '')
}
